<ng-container *transloco="let t">
  <div class="modal-header">

    <h2>{{ t('wizard.employmentHistory.dialogTitle') }}</h2>

    <!-- hack to fool ngbModal autofocus -->
    <input type="text" style="display:none" />

    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" [attr.aria-label]="t('common.close')"
      (click)="activeModal.dismiss()">
      <span class="svg-icon svg-icon-2x">
        <close-x-svg-icon></close-x-svg-icon>
      </span>
    </div>
  </div>

  <div class="modal-body py-10 px-lg-17">
    <form #employmentInfoForm="ngForm" class="form" novalidate id="employmentInfoForm" name="employmentInfoForm">
      <div class="me-n7 pe-7">
        <div class="row mb-5">
          <div class="col-md-6 fv-row">
            <label class="required form-label mb-2">{{ t('wizard.employmentHistory.employerName') }}</label>
            <input type="text" class="form-control form-control-solid"
              [ngClass]="{'is-invalid' : employer && employer.touched && employer.invalid}" #employer="ngModel"
              [(ngModel)]="employment.employer" placeholder="" name="employer" required />
            <div class="invalid-feedback">{{ t('wizard.employmentHistory.employerRequired') }}</div>
          </div>
          <div class="col-md-6 fv-row">
            <label class="required form-label mb-2">{{ t('wizard.employmentHistory.position') }}</label>
            <input type="text" class="form-control form-control-solid"
              [ngClass]="{'is-invalid' : position && position.touched && position.invalid}" #position="ngModel"
              [(ngModel)]="employment!.position" placeholder="" name="position" required />
            <div class="invalid-feedback">{{ t('wizard.employmentHistory.positionRequired') }}</div>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-md-6 fv-row">
            <label class="required form-label mb-2">{{ t('wizard.employmentHistory.startDate') }}</label>
            <input class="form-control form-control-solid" matInput mask="00/00/0000" [showMaskTyped]="true" [specialCharacters]="[ '/' ]"
              [dropSpecialCharacters]="false" datePicker
              [ngClass]="{'is-invalid' : startDate && startDate.touched && startDate.invalid}" #startDate="ngModel" inputmode="numeric"
              required [(ngModel)]="employment!.startDate" placeholder="" name="startDate" ngControl="startDate" id="startDate" />
            <div [ngStyle]="{'display':startDate && startDate.touched && startDate.invalid ? 'block' : 'none' }" class="invalid-feedback">{{ t('wizard.employmentHistory.startDateRequired') }}</div>
          </div>
          <div class="col-md-6 fv-row">
            <label class="form-label mb-2">{{ t('wizard.employmentHistory.endDate') }}</label>
            <input class="form-control form-control-solid" matInput mask="00/00/0000" [showMaskTyped]="true"
              [specialCharacters]="[ '/' ]" [dropSpecialCharacters]="false" datePicker
              [ngClass]="{'is-invalid' : endDate && endDate.touched && endDate.invalid}" #endDate="ngModel" inputmode="numeric"
              [(ngModel)]="employment!.endDate" placeholder="" name="endDate" ngControl="endDate" id="endDate" />
            <div [ngStyle]="{'display':startDate && startDate.touched && startDate.invalid ? 'block' : 'none' }" class="invalid-feedback">{{ t('wizard.employmentHistory.endDateRequired') }}</div>
            <div [ngStyle]="{'display':isEndDateInFutureMessageShowing ? 'block' : 'none' }" class="invalid-feedback">{{ t('wizard.employment.endDateInFuture') }}</div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer flex-center">
    <button type="button" class="btn btn-white me-3" (click)="activeModal.dismiss()">{{ t('common.cancel') }}</button>
    <button type="button" class="btn btn-primary" (click)="onSaveClicked()">{{ t('common.ok') }}</button>
  </div>
</ng-container>
